/**
 * Architecture scenes — shared atoms used across the 7 architecture scenes.
 */
import { motion } from 'framer-motion';

export function SceneFrame({ title, subtitle, eyebrow, children }) {
  return (
    <div className="w-full max-w-6xl mx-auto px-10 py-8">
      {eyebrow && (
        <motion.p
          initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }}
          className="text-[11px] font-body font-semibold tracking-[0.2em] uppercase text-teal-600 mb-2"
        >{eyebrow}</motion.p>
      )}
      {title && (
        <motion.h1
          initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
          className="font-heading font-extrabold text-[36px] leading-tight tracking-tight text-[#0A0A0A]"
        >{title}</motion.h1>
      )}
      {subtitle && (
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}
          className="mt-2 font-body text-[14px] text-[#6B7280] max-w-3xl"
        >{subtitle}</motion.p>
      )}
      <div className="mt-8">{children}</div>
    </div>
  );
}

export function ArchCard({ children, className = '', delay = 0, ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className={`rounded-2xl bg-white border border-[#E5E7EB] shadow-sm ${className}`}
      {...rest}
    >{children}</motion.div>
  );
}

export function Pill({ tone = 'slate', children }) {
  const tones = {
    slate:   'bg-slate-100 text-slate-700 border-slate-200',
    teal:    'bg-teal-100 text-teal-800 border-teal-200',
    amber:   'bg-amber-100 text-amber-800 border-amber-200',
    indigo:  'bg-indigo-100 text-indigo-800 border-indigo-200',
    emerald: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    rose:    'bg-rose-100 text-rose-700 border-rose-200',
  };
  return (
    <span className={`inline-block px-2.5 py-0.5 rounded-md text-[11px] font-body font-semibold border ${tones[tone]}`}>
      {children}
    </span>
  );
}
